enum enArrowDirection {
    Left,
    Right,
}

export default enArrowDirection;
